// src/components/common/ErrorBoundary.jsx
import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  handleGoLogin = () => {
    window.location.href = "/login";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#F6FAF7",
            padding: "1.5rem",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            color: "#1B4B31",
          }}
        >
          <div
            style={{
              maxWidth: "520px",
              width: "100%",
              backgroundColor: "#FFFFFF",
              borderRadius: "16px",
              padding: "2.5rem 2rem",
              boxShadow: "0 10px 25px rgba(27, 75, 49, 0.08)",
              border: "1px solid #D8E6DE",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "56px",
                height: "56px",
                backgroundColor: "#EAF4EE",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 1.25rem",
                color: "#1B4B31",
                fontSize: "1.75rem",
              }}
            >
              ⚠️
            </div>

            <h2
              style={{
                fontSize: "1.4rem",
                fontWeight: 700,
                color: "#1B4B31",
                margin: "0 0 0.5rem",
              }}
            >
              Something went wrong
            </h2>

            <p
              style={{
                fontSize: "0.92rem",
                color: "#486654",
                lineHeight: 1.5,
                margin: "0 0 1.5rem",
              }}
            >
              An unexpected error occurred while rendering this page. You can try reloading or navigating back to the main dashboard.
            </p>

            {this.state.error && (
              <details
                style={{
                  textAlign: "left",
                  backgroundColor: "#F3F7F4",
                  padding: "0.75rem 1rem",
                  borderRadius: "8px",
                  fontSize: "0.8rem",
                  color: "#991B1B",
                  fontFamily: "monospace",
                  marginBottom: "1.5rem",
                  wordBreak: "break-all",
                  cursor: "pointer",
                }}
              >
                <summary style={{ fontWeight: 600, color: "#1B4B31", cursor: "pointer" }}>
                  View technical error details
                </summary>
                <div style={{ marginTop: "0.5rem", whiteSpace: "pre-wrap" }}>
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </div>
              </details>
            )}

            <div
              style={{
                display: "flex",
                gap: "0.75rem",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={this.handleReload}
                style={{
                  backgroundColor: "#1B4B31",
                  color: "#FFFFFF",
                  border: "none",
                  padding: "0.65rem 1.25rem",
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  cursor: "pointer",
                  transition: "background 0.2s",
                }}
              >
                Reload Page
              </button>
              <button
                onClick={this.handleGoHome}
                style={{
                  backgroundColor: "#EAF4EE",
                  color: "#1B4B31",
                  border: "1px solid #D8E6DE",
                  padding: "0.65rem 1.25rem",
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  cursor: "pointer",
                }}
              >
                Go to Dashboard
              </button>
              <button
                onClick={this.handleGoLogin}
                style={{
                  backgroundColor: "transparent",
                  color: "#486654",
                  border: "1px solid #D8E6DE",
                  padding: "0.65rem 1.25rem",
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  cursor: "pointer",
                }}
              >
                Login
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
